/**
 * Arquivo de store para a entidade Question
 */
// Import axios
import axios from "axios";
import router from "../router";
import RDService from "@/services/RD.service";

// Configurações do axios
var _axios = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Verifica se tem leadid no storage
var leadId = localStorage.getItem("leadId");

const QuestionModule = {
  state: {
    questions: [],
    answers: [],
    step: 1,
    leadId: leadId ? leadId : null, // usado no cadastro das perguntas
    answersResult: [],
    form: {},
    score: 0,
  },
  mutations: {
    SET_QUESTIONS(state, questions) {
      state.questions = questions;
    },
    SET_ANSWERS(state, answers) {
      state.answers = answers;
    },
    SET_STEP(state, step) {
      state.step = step;
    },
    SET_LEAD_ID(state, leadId) {
      state.leadId = leadId;

      // salva o lead id no local storage
      localStorage.setItem("leadId", leadId);
    },
    SET_ANSWERS_RESULT(state, answersResult) {
      state.answersResult = answersResult;
    },
    SET_CURRENT_USER(state, form) {
      state.form = form;
    },
  },
  actions: {
    async integraRD({ commit, state, dispatch }) {
      // console.log("integra", state.answersResult, state.form)

      let score = 0;

      for (let i = 0; i < state.answersResult.values.length; i++) {
        score += parseInt(state.answersResult.values[i].peso);
      }

      score = score / state.answersResult.values.length;

      score = score / 10;

      score = score > 10 ? 10 : score;

      var service = new RDService();
      const res = await service.sendConversion(
        state.form.email,
        score,
        state.answersResult.externalId
      );
    },
    async getQuestions({ commit, state }) {
      const response = await _axios.get("/question/list");

      var answers = response.data.map((question) => {
        return {
          question: question.id,
          answer: undefined,
        };
      });

      // Atualiza as de respostas com bases nas perguntas
      commit("SET_ANSWERS", answers);

      commit("SET_QUESTIONS", response.data);
    },
    async updateStep({ commit }, step) {
      commit("SET_STEP", step);
    },
    // next step
    async nextStep({ commit, state, dispatch }) {
      var maxStep = state.questions.length;
      var newStep = state.step + 1;

      if (state.step < maxStep) {
        commit("SET_STEP", newStep);
      }

      // Valida se é o ultimo passo
      if (newStep > maxStep) {
        // Salva as respostas
        await dispatch("saveAnswer");
      }
    },
    // previous step
    async prevStep({ commit, state }) {
      var newStep = state.step - 1;
      if (newStep < 1) {
        newStep = 1;
      }
      commit("SET_STEP", newStep);
    },

    // Salva as respostas
    async saveAnswer({ commit, state, dispatch }) {
      // Valida as respostas

      // Monta objeto com as respostas para a base
      const answers = makeObjAnswer(state);

      // soma os valores do peso das respostas
      //TODO mudar para o back o calculo
      answers.evaluation = answers.values.reduce((acc, cur) => {
        return acc + cur.peso;
      }, 0);

      try {
        // Salva as respostas e envia o leadId
        const response = await _axios.post("/answer/add", answers);
        const answerId = response.data.answerId;
        // commit('SET_ANSWERS_RESULT', process.env.VUE_APP_ROOT+'/result/'+ answerId);
        // commit('SET_ANSWERS_SCORE', answerId);

        await dispatch("getAnswersResult", answerId);
        await dispatch("integraRD");

        // Limpa o lead do localstorage
        localStorage.removeItem("leadId");

        // redireciona para a página de resultado com answerId
        router.push({
          path: `/result/${answerId}`,
        });
        // window.location.href = `/result/${answerId}`;
      } catch (error) {
        console.log(error);
      }
    },

    // Salva as respostas
    async getAnswersResult({ commit, state }, answerId) {
      // Pega as respostas do servidor por answerId
      const response = await _axios.get(`/answer/getAnswersByExternalId?externalId=${answerId}`);

      // Atualiza as respostas
      commit("SET_ANSWERS_RESULT", response.data);
    },
  },
  getters: {
    questions: (state) => state.questions,
    question: (state) => state.question,
    answers: (state) => state.answers,
    step: (state) => state.step,
    leadId: (state) => state.leadId,
    answersResult: (state) => state.answersResult,
    answersActual: (state) => {
      return state.answers ? state.answers[state.step - 1] : null;
    },
    currentUser: (state) => state.form,
    isLastStep: (state) => state.step >= state.questions.length,
  },
};

export default QuestionModule;

function makeObjAnswer(state) {
  // monta o objeto de respostas
  var answers = {
    leadId: state.leadId,
    evaluation: 1,
    values: [],
  };

  // Monta o objeto de respostas
  state.answers.forEach((answer) => {
    // pega a pergunta
    var question = state.questions.find((question) => question.id == answer.question);

    // encontra a resposta
    var answerValue = question.options.find((option) => option.id == answer.answer);

    answers.values.push({
      optionId: answerValue.id,
      value: answerValue.answer,
      peso: answerValue.value,
    });
  });

  return answers;
}
